/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'

export interface TenantState {
  invitationCode: types.InvitationCode|null
  [key: string]: any
}

const Tenant = defineModule({
  state: (): TenantState => {
    return {
      invitationCode: null
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    },
  },
  actions: {
    async getInvitationCode (context, code): Promise<boolean> {
      const { commit, dispatch } = moduleActionContext(context, Tenant)
      try {
        const result = await Lib.Ajax.getHandleError<types.DataResponse<types.InvitationCode>>('/api/tenant/getinvitation/' + code,'取得に失敗しました。', {})
        commit.SET_VALUE({ name: 'invitationCode', value: result.data.data })
        return true
      } catch {
        return false
      }
    },
    async addTenant (context): Promise<boolean> {
      const { state } = moduleActionContext(context, Tenant)
      try {
        await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/tenant/addtenant','生成に失敗しました。',
        {
          code: state.invitationCode?.code ?? '',
          tenantId: state.invitationCode?.tenantId ?? '',
          email: state.invitationCode?.email ?? '',
          password: state.invitationCode?.password ?? ''
        }, null)
        return true
      } catch {
        return false
      }
    },
  },
  namespaced: true
})
export default Tenant
